document.addEventListener('DOMContentLoaded', function () {
    var revealButtons = document.querySelectorAll('.reveal-btn'); // Adjusted the selector

    // Function to set default height based on current structure
    function setDefaultHeight(content) {
        var h4Height = content.querySelector('h3').offsetHeight; // Adjusted to select h4
        var defaultHeight = h4Height + 100; // Example calculation
        content.style.height = defaultHeight + 'px'; // Set initial default height
    }

    // Set the default height for all reveal-content areas initially
    document.querySelectorAll('.reveal-content').forEach(function(content) {
        setDefaultHeight(content); // Adjusted to pass the content element
    });

    revealButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var content = this.previousElementSibling; // Correct assumption

            if (content.style.height !== 'auto' && content.style.height !== content.scrollHeight + 'px') {
                content.style.height = content.scrollHeight + 'px';
                this.innerHTML = '<span>View Less</span>' + this.innerHTML.substring(this.innerHTML.indexOf('<svg'));
                content.classList.add('expanded');
            } else {
                setDefaultHeight(content); // Adjust to revert to default
                this.innerHTML = '<span>View More</span>' + this.innerHTML.substring(this.innerHTML.indexOf('<svg'));
                content.classList.remove('expanded');
            }
        });
    });
});